import "./BeneficioCard.scss";

function BeneficioCard({text, children, className}) {
  return (
    <div className={`beneficio-card ${className}`}>
      <div className="beneficio-img">{children}</div>
      <div className="beneficio-text">{text}</div>
    </div>
  );
}

export default BeneficioCard;
